import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { isAuth0TokenError } from '../../services/common-utils/common-utils';
import { ErrorMessages } from '../../constants/project.constant';

@Injectable({
    providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private readonly toastr: ToastrService,
        private readonly router: Router) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: any) => {
                if (error instanceof HttpErrorResponse) {
                    if (error.status === 401) {
                        this.toastr.error(ErrorMessages.unauthorized);
                        this.router.navigate(['/access-denied']);
                        return EMPTY;
                    }
                    if (error.status === 403) {
                        this.toastr.error(ErrorMessages.forbidden);
                        this.router.navigate(['/access-denied']);
                        return EMPTY;
                    }
                }
                // Auth0 token errors (expired refresh token, missing token, etc.)
                // are handled by app.component.ts handleAuth0Error() via auth.error$
                // Suppress them here to prevent service-level toasts
                if (isAuth0TokenError(error)) {
                    return EMPTY;
                }
                throw error;
            })
        );
    }
}
